/** @file Stepped sampler for inherit and attachment timelines (no curves, no interpolation). */
import type { Sample } from '../../contracts/sample';
import type { TimelineData } from '../../skeletonData';
import { locateKey, type KeyCursor } from './locateKey';

const cur: KeyCursor = { k0: 0, k1: 0, u: 0 };

type DiscreteTimeline = Extract<TimelineData, { k: 'inherit' | 'attachment' }>;

/** Writes the held key's inherit code into Sample.inherit or its placeholder id into Sample.attachments. */
export const discreteHandler = {
  sample(tl: DiscreteTimeline, time: number, lastTime: number, out: Sample): void {
    if (!locateKey(tl.times, time, cur)) return;
    if (tl.k === 'inherit') out.inherit[tl.bone] = tl.values[cur.k0] ?? 0;
    else out.attachments[tl.slot] = tl.values[cur.k0] ?? -1;
  },
};
